/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type SharedRespMoreWaysToBrowse_internalBuyLinks$ref = any;
export type SharedRespMoreWaysToBrowse_internalBuyLinks = ReadonlyArray<{
    readonly anchorText: string | null;
    readonly url: string | null;
    readonly " $refType": SharedRespMoreWaysToBrowse_internalBuyLinks$ref;
}>;



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SharedRespMoreWaysToBrowse_internalBuyLinks",
    "type": "InternalBuyLinkType",
    "metadata": {
        "plural": true
    },
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "anchorText",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "url",
            "args": null,
            "storageKey": null
        }
    ]
} as any);
(node as any).hash = 'eaf203383eee7ec343917d87f941e4ad';
export default node;
